import { z } from 'zod';

export const schemaConsorsSubscriberIdentifierInternal = z
    .string()
    .min(1)
    .max(14)
    .regex(/^[0-9]+$/, 'Invalid characters');
